import { useSelector } from 'react-redux';
import _ from 'lodash';

// Import variables
import { PRODUCTS_TYPES } from 'helpers/variables';

const { MAIN } = PRODUCTS_TYPES;

const useProductAvailability = ({ uuid, available_in, subtype }) => {
	const userProducts = useSelector(({ auth }) => auth.products);
	const freeProducts = useSelector(({ free_products }) => free_products.data);
	const subscriptions = useSelector(
		({ activeSubscriptions }) => activeSubscriptions.data
	);

	if (subtype === MAIN) {
		return subscriptions.some(({ product_uuid }) => product_uuid === uuid);
	}

	const products = _.uniq([...userProducts, ...freeProducts]);

	const availableIn = available_in ?? [];

	return [...availableIn, uuid].some((id) => products.includes(id));
};

export default useProductAvailability;
